/**
 * Size an Element
 *
 * @param width (1em) - Width of the element
 * @param height - Height of the element
 */

export const size = (width = "1em", height = ""): string => `
  height: ${height || width};
  width: ${width};
`;
